import React, { useEffect, useState } from 'react';
import { Megaphone, AlertTriangle, X } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

// Sitewide-Ankuendigungsbanner. Inhalt kommt vom oeffentlichen Endpunkt
// GET /api/announcement (per Admin-CLI gesetzt/entfernt). Pro Nutzer
// schliessbar; eine neue Ankuendigung (andere id) wird wieder angezeigt.
export default function AnnouncementBanner() {
  const { t } = useLanguage();
  const [ann, setAnn] = useState(null);
  const [dismissedId, setDismissedId] = useState(
    () => localStorage.getItem('dismissed_announcement') || ''
  );

  const load = async () => {
    try {
      const res = await fetch('/api/announcement', { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const data = await res.json();
      setAnn(data && data.active ? data : null);
    } catch (e) {
      /* still/offline -> Banner einfach nicht anzeigen */
    }
  };

  useEffect(() => {
    load();
    const iv = setInterval(load, 60000);
    return () => clearInterval(iv);
  }, []);

  if (!ann || dismissedId === ann.id) return null;

  const warning = ann.type === 'warning';
  const Icon = warning ? AlertTriangle : Megaphone;

  const dismiss = () => {
    localStorage.setItem('dismissed_announcement', ann.id || '');
    setDismissedId(ann.id || '');
  };

  return (
    <div
      role="status"
      className={`w-full border-b backdrop-blur-sm ${
        warning ? 'bg-amber-500/10 border-amber-500/20' : 'bg-secondary/40 border-border/30'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 py-2.5 flex items-center gap-3">
        <Icon className={`w-4 h-4 shrink-0 ${warning ? 'text-amber-500' : 'text-primary'}`} />
        <p className="text-sm flex-1 min-w-0 text-foreground break-words">{ann.message}</p>
        <button
          onClick={dismiss}
          aria-label={t('announcementClose')}
          className="shrink-0 p-1 rounded-md text-muted-foreground hover:bg-foreground/10 hover:text-foreground transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
